import React, { useEffect, useState } from "react";
import phaseimg1 from "./Assets/phase111.webp";
import phaseimg2 from "./Assets/phase222.webp";
import phaseimg3 from "./Assets/phase333.webp";
import phaseimg4 from "./Assets/phase444.webp";
import phaseimg5 from "./Assets/phase555.webp";
import liimg from "./Assets/li_img.webp";

function Roadmap() {

  return (

    <div className="pb-3">

      <h2 className="nebula text-white text-center text-uppercase pt-5 pb-4 big_font">
        {/* Roadmap and <br></br> development timeline */}
        ROADMAP
      </h2>

      <div className="row">
        <div className="col-xl-11 col-xxl-9 mx-auto">
          <div className="d-flex pos_list gap-3">
            <img className="img-fluid phaseimg" src={phaseimg1} alt="Landfall" width="116px" height="100px"/>
            <div>
              <h2 class="nebula text-white">Phase 1: Q2-Q3, 2026  </h2>
              <p className="text-white nebula overflow_wraps galfi_roadmaptxt mb-0 ">Landfall 
                {/* (Q4 2024) */}
                </p>
            </div>
          </div>
          <ul className="roadmap_section mt-4">
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>The GALFI token & 14 on-chain resource tokens are minted</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Galfi Nexus NFT Marketplace created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Micro Shuttle Ship NFTs created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Buildings created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Mining, Exploration, Social, and Combat missions created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Ships and Mechs NFTs created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>10,000 Crew NFTs created with XP points system</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>10,000 Specialist NFTs created with XP points system</span></li>
          </ul>


          {/* <div className="d-flex pos_list gap-3 mt-5">
            <img className="img-fluid phaseimg" src={phaseimg2} alt="Reinforcements" width="116px" height="100px"/>
            <div>
            <h2 class="nebula text-white">Phase 2: Q4, 2026</h2>
              <p className="text-white nebula overflow_wraps galfi_roadmaptxt mb-0">Colonization 
              </p>
            </div>
          </div>
          <ul className="roadmap_section mt-4">
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>10K Specialist NFTS created with XP points system</span></li>
          </ul> */}



          <div className="d-flex pos_list gap-3 mt-5">
            <img className="img-fluid phaseimg" src={phaseimg3} alt="Colonisation" width="116px" height="100px"/>
            <div>
            <h2 class="nebula text-white">Phase 2: Q4 2026            </h2>
              <p className="text-white nebula overflow_wraps galfi_roadmaptxt mb-0">Colonisation
                 {/* (Q1 2025 / Q2 2025) */}
              </p>
            </div>
          </div>
          <ul className="roadmap_section mt-4">
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Colony Ships created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>50,000 system (HEX) star map created</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>‘Random events’ for exploration in Contested Space created
            </span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>PVP rules introduced for ship battles, and colony invasions (Contested space zone)</span></li>
          </ul>


          <div className="d-flex pos_list gap-3 mt-5">
            <img className="img-fluid phaseimg" src={phaseimg4} alt="Mission Control" width="116px" height="100px"/>
            <div>
            <h2 class="nebula text-white">Phase 3: Q1, 2027</h2>
              <p className="text-white nebula overflow_wraps galfi_roadmaptxt mb-0">Mission Control
                 {/* (Q1 2025 / Q2 2025) */}
              </p>
            </div>
          </div>
          <ul className="roadmap_section mt-4">
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>‘Random events’ on missions begin
            </span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>More advanced mini games on missions begin
            </span></li>
          </ul>


          <div className="d-flex pos_list gap-3 mt-5">
            <img className="img-fluid phaseimg" src={phaseimg5} alt="Deep Future" width="116px" height="100px"/>
            <div>
            <h2 class="nebula text-white">Phase 4: Q2, 2027</h2>
              <p className="text-white nebula overflow_wraps galfi_roadmaptxt mb-0">Deep Future 
                {/* (Q1 2025 / Q2 2025 Onwards) */}
              </p>
            </div>
          </div>
          <ul className="roadmap_section mt-4">
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>NNew utility for GALFI and resource tokens planned 
            </span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>New Buildings & Ships planned</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>External NFT collections added through partnerships with other NFT projects</span></li>
            <li><img src={liimg} alt="square" width="32px" height="32px"/> <span>Bounties will be offered to those who help build out the Galfi Metaverse/provide further utility for GalFi tokenised resources and NFTs
            </span></li>
          </ul>


        </div>

      </div>

    </div>


  )
}

export default Roadmap